export default __webpack_public_path__ + "static/media/Endscenario-2.9f090668.png";